import useModal from '@/hooks/useModal'
import ModalCustom from '@/scenes/Editor/components/Modal/Modal'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { consumeModalCallbacks } from '@/store/slices/modal/callbackRegistry'
import { useTranslation } from 'react-i18next'
import { useRef } from 'react'

function ModalCustomText() {
  const { showModalType, setShowModalType, customTextProps } = useModal()
  const { t } = useTranslation()

  // Retain the last non-null props so content remains visible during the close animation,
  // which runs after customTextProps is cleared from the store.
  const lastPropsRef = useRef(customTextProps)
  if (customTextProps !== null) {
    lastPropsRef.current = customTextProps
  }

  const { header, text, primaryButtonText, secondaryButtonText, showSecondaryButton = false, callbackGeneration, primaryButtonVariant } =
    lastPropsRef.current ?? {}

  const handlePrimary = () => {
    if (callbackGeneration != null) {
      const cbs = consumeModalCallbacks(callbackGeneration)
      if (cbs === null) return
      cbs.onPrimary?.()
    }
    setShowModalType(null)
  }

  const handleSecondary = () => {
    if (callbackGeneration != null) {
      const cbs = consumeModalCallbacks(callbackGeneration)
      if (cbs === null) return
      cbs.onSecondary?.()
    }
    setShowModalType(null)
  }

  return (
    <ModalCustom
      isOpen={showModalType === ShowModalType.CUSTOM_TEXT}
      onClose={handleSecondary}
      content={{
        header,
        desc: text,
      }}
      action={{
        primary: {
          name: primaryButtonText || t('OK'),
          handle: handlePrimary,
          variant: primaryButtonVariant,
        },
        ...(showSecondaryButton && {
          secondary: {
            name: secondaryButtonText || t('Cancel'),
            handle: handleSecondary,
          },
        }),
      }}
    />
  )
}

export default ModalCustomText
